import React from "react";
import { TableHeadersType } from "../../../../constant/tableHeadersConstants/tableHeadersType";
import { CircularAvatar } from "../../../commons";
import {
  currencySignAndNegativeValueAdjust,
  formateDateWithTime,
  reverseDate,
} from "../../../../utils/commonFunctions";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Link } from "react-router-dom";
import { DayBookReportsListType } from "../../../../commonTypes/reportsTypes";
type AppProps = {
  tableHeaders: TableHeadersType[];
  tableData: DayBookReportsListType[] | [];
  clientCode: number;
  companyName: string;
  startDate: string;
  endDate: string;
  currencySign: string | undefined;
  isLedgerStatementPresent?: boolean;
};

const DayBookTableData = ({
  tableHeaders,
  tableData,
  clientCode,
  companyName,
  startDate,
  endDate,
  currencySign,
  isLedgerStatementPresent,
}: AppProps) => {
  //redirection to ledger statement
  const finalRedirectLink = {
    pathname: `/reports/${clientCode}/ledger-statement?client_code=${clientCode}&company_name=${companyName}`,
  };

  const handleSetLocalStorageData = (ledgerId: number) => {
    localStorage.setItem("ledger_id", ledgerId.toString());
    localStorage.setItem("start_date", reverseDate(startDate));
    localStorage.setItem("end_date", reverseDate(endDate));
  };

  const backgroundColorFun = (name: string) => {
    let backgroundColor;
    let fontColor;
    if (name === "debit_note") {
      backgroundColor = "#fde0d3";
      fontColor = "#e7733e";
    } else if (name === "credit_note") {
      backgroundColor = "#e7f0d4";
      fontColor = "#82b01f";
    } else if (name === "tax_invoice") {
      backgroundColor = "#d4edf0";
      fontColor = "#2d8589";
    } else if (name === "estimation") {
      backgroundColor = "#e3efff";
      fontColor = "#2080f6";
    } else if (name === "rcm_invoice") {
      backgroundColor = "rgb(238, 241, 244)";
      fontColor = "rgb(110, 116, 145)";
    } else {
      backgroundColor = "rgb(237, 230, 252)";
      fontColor = "rgb(116, 75, 209)";
    }
    return {
      backgroundColor,
      fontColor,
    };
  };

  const styleDocumentType = (name: string) => {
    const { backgroundColor, fontColor } = backgroundColorFun(name);
    return {
      marginTop: "20px",
      padding: "2px 12px 4px",
      color: fontColor,
      background: backgroundColor,
      borderRadius: "16px",
    };
  };

  const empty = () => {
    return (
      <td className="ml-2" style={{ border: "0px" }}>
        --/--
      </td>
    );
  };
  return (
    <>
      {tableData?.length > 0 &&
        tableData?.map((data: any) => {
          let finalLink =
            data?.invoice_type === 1 || data?.invoice_type === 2
              ? `/invoice-generation/edit/${
                  data?.invoice_id
                }/${clientCode}?type=${
                  data?.invoice_type === 1 ? "expenses" : "revenues"
                }&client_code=${clientCode}&company_name=${companyName}`
              : `/invoice-generation/edit-others/${clientCode}/${data?.invoice_id}?type=others&client_code=${clientCode}&company_name=${companyName}`;
          return (
            <tr className="text-start" key={data?.invoice_id}>
              {tableHeaders?.map((header: TableHeadersType) => {
                if (header?.value === "date") {
                  return (
                    <td className="text-start" style={{ minWidth: "120px" }}>
                      {data?.invoice_date
                        ? reverseDate(data?.invoice_date?.split("T")[0])
                        : reverseDate(data?.date_of_invoice)}
                    </td>
                  );
                } else if (header?.value === "approved_by") {
                  return (
                    <td className="text-start">
                      <div className="d-flex">
                        {data?.approval_details?.length > 0
                          ? data?.approval_details?.map((profileData: any) => {
                              let fullName = `${profileData?.first_name} ${
                                profileData?.last_name
                                  ? profileData?.last_name
                                  : ""
                              }`;
                              return (
                                <OverlayTrigger
                                  placement="top"
                                  delay={{ show: 250, hide: 250 }}
                                  overlay={
                                    <Tooltip id="button-view-open-item">
                                      {fullName}
                                      <br></br>
                                      approved on{" "}
                                      {formateDateWithTime(
                                        profileData?.approved_at
                                      )}
                                    </Tooltip>
                                  }
                                >
                                  <span
                                    style={{
                                      cursor: "pointer",
                                      marginLeft: "3px",
                                    }}
                                  >
                                    <CircularAvatar
                                      image={profileData?.profile_pic?.file_url}
                                      name={fullName}
                                    />
                                  </span>
                                </OverlayTrigger>
                              );
                            })
                          : "--/--"}
                      </div>
                    </td>
                  );
                } else if (header?.value === "invoice_no") {
                  return (
                    <td style={{ minWidth: "120px" }}>
                      <Link
                        style={{
                          textDecoration: "none",
                          cursor: "pointer",
                          color: "black",
                        }}
                        target="_blank"
                        to={finalLink}
                      >
                        <span
                          style={{
                            textDecoration: "underline",
                            textUnderlineOffset: "0.3em",
                            color: "#262a44",
                            fontWeight: "500",
                          }}
                        >
                          {data?.invoice_number ? data?.invoice_number : "N/A"}
                        </span>
                      </Link>
                    </td>
                  );
                } else if (header?.value === "narration") {
                  return (
                    <td style={{ minWidth: "130px", wordWrap: "break-word" }}>
                      {data?.narration_in_bank
                        ? data?.narration_in_bank
                        : "--/--"}
                    </td>
                  );
                } else if (header?.value === "invoice_type") {
                  return (
                    <td style={{ minWidth: "130px" }}>
                      {data?.invoice_type === 1
                        ? "Expense"
                        : data?.invoice_type === 2
                        ? "Sales"
                        : "Other"}{" "}
                      Entry
                    </td>
                  );
                } else if (header?.value === "document_type") {
                  return (
                    <td style={{ minWidth: "250px" }}>
                      {" "}
                      <span
                        style={
                          data?.document_type?.value &&
                          styleDocumentType(data?.document_type?.value)
                        }
                      >
                        {data?.document_type?.value
                          ? data?.document_type?.label
                          : "--/--"}
                      </span>
                    </td>
                  );
                } else if (header?.value === "ledger_name") {
                  const ledgerFun = () => {
                    if (data?.payment?.length > 0) {
                      return (
                        data?.payment?.length > 0 && (
                          <td
                            className={
                              data?.payment?.length
                                ? "d-flex flex-column p-0"
                                : ""
                            }
                            style={{ border: "0px" }}
                          >
                            {data?.payment?.map(
                              (ledger: any, index: number) => {
                                return (
                                  <td
                                    className={
                                      index === data?.payment?.length - 1
                                        ? "border-0"
                                        : ""
                                    }
                                    style={{
                                      borderTop: "0px",
                                      borderRight: "0px",
                                      borderLeft: "0px",
                                      height: "58px",
                                    }}
                                  >
                                    <div
                                      className="d-flex flex-column"
                                      style={{ marginTop: "-6px" }}
                                    >
                                      {isLedgerStatementPresent ? (
                                        <Link
                                          target="_blank"
                                          to={finalRedirectLink}
                                          onClick={() =>
                                            handleSetLocalStorageData(
                                              ledger?.account_details?.ledger_id
                                            )
                                          }
                                          style={{
                                            textDecoration: "none",
                                            cursor: "pointer",
                                          }}
                                        >
                                          {ledger?.account_details?.ledger_name
                                            ?.length > 20 ? (
                                            <OverlayTrigger
                                              placement="top"
                                              delay={{ show: 250, hide: 250 }}
                                              overlay={
                                                <Tooltip id="button-view-open-item">
                                                  {
                                                    ledger?.account_details
                                                      ?.ledger_name
                                                  }
                                                </Tooltip>
                                              }
                                            >
                                              <span
                                                className="text-start pointer"
                                                style={{
                                                  color: "#262a44",
                                                  fontWeight: "500",
                                                  fontSize: "14px",
                                                  textDecoration: "underline",
                                                  textUnderlineOffset: "0.3em",
                                                  whiteSpace: "nowrap",
                                                }}
                                              >
                                                {ledger?.account_details?.ledger_name.slice(
                                                  0,
                                                  20
                                                )}
                                                ...
                                              </span>
                                            </OverlayTrigger>
                                          ) : (
                                            <span
                                              className="text-start pointer"
                                              style={{
                                                color: "#262a44",
                                                fontWeight: "500",
                                                fontSize: "14px",
                                                textDecoration: "underline",
                                                textUnderlineOffset: "0.3em",
                                                whiteSpace: "nowrap",
                                              }}
                                            >
                                              {
                                                ledger?.account_details
                                                  ?.ledger_name
                                              }
                                            </span>
                                          )}
                                        </Link>
                                      ) : ledger?.account_details?.ledger_name
                                          ?.length > 20 ? (
                                        <OverlayTrigger
                                          placement="top"
                                          delay={{ show: 250, hide: 250 }}
                                          overlay={
                                            <Tooltip id="button-view-open-item">
                                              {
                                                ledger?.account_details
                                                  ?.ledger_name
                                              }
                                            </Tooltip>
                                          }
                                        >
                                          <span
                                            className="text-start"
                                            style={{
                                              color: "#262a44",
                                              fontSize: "14px",
                                              textUnderlineOffset: "0.3em",
                                              whiteSpace: "nowrap",
                                            }}
                                          >
                                            {ledger?.account_details?.ledger_name.slice(
                                              0,
                                              20
                                            )}
                                            ...
                                          </span>
                                        </OverlayTrigger>
                                      ) : (
                                        <span
                                          className="text-start pointer"
                                          style={{
                                            color: "#262a44",
                                            fontSize: "14px",
                                            textUnderlineOffset: "0.3em",
                                            whiteSpace: "nowrap",
                                          }}
                                        >
                                          {ledger?.account_details?.ledger_name}
                                        </span>
                                      )}
                                    </div>
                                  </td>
                                );
                              }
                            )}
                          </td>
                        )
                      );
                    } else if (data?.ledger_details) {
                      return (
                        data?.ledger_details && (
                          <td
                            className={
                              data?.ledger_details?.length
                                ? "d-flex flex-column p-0"
                                : ""
                            }
                            style={{ border: "0px" }}
                          >
                            <div className="d-flex flex-column">
                              {isLedgerStatementPresent ? (
                                <Link
                                  target="_blank"
                                  to={finalRedirectLink}
                                  onClick={() =>
                                    handleSetLocalStorageData(
                                      data?.ledger_details?.ledger_id
                                    )
                                  }
                                  style={{
                                    textDecoration: "none",
                                    cursor: "pointer",
                                  }}
                                >
                                  {data?.ledger_details?.legal_name?.length >
                                  20 ? (
                                    <OverlayTrigger
                                      placement="top"
                                      delay={{ show: 250, hide: 250 }}
                                      overlay={
                                        <Tooltip id="button-view-open-item">
                                          {data?.ledger_details?.legal_name}
                                        </Tooltip>
                                      }
                                    >
                                      <span
                                        className="text-start pointer"
                                        style={{
                                          color: "#262a44",
                                          fontWeight: "500",
                                          fontSize: "14px",
                                          textDecoration: "underline",
                                          textUnderlineOffset: "0.3em",
                                          whiteSpace: "nowrap",
                                        }}
                                      >
                                        {data?.ledger_details?.legal_name.slice(
                                          0,
                                          20
                                        )}
                                        ...
                                      </span>
                                    </OverlayTrigger>
                                  ) : (
                                    <span
                                      className="text-start pointer"
                                      style={{
                                        color: "#262a44",
                                        fontWeight: "500",
                                        fontSize: "14px",
                                        textDecoration: "underline",
                                        textUnderlineOffset: "0.3em",
                                        whiteSpace: "nowrap",
                                      }}
                                    >
                                      {data?.ledger_details?.legal_name}
                                    </span>
                                  )}
                                </Link>
                              ) : data?.ledger_details?.legal_name?.length >
                                20 ? (
                                <OverlayTrigger
                                  placement="top"
                                  delay={{ show: 250, hide: 250 }}
                                  overlay={
                                    <Tooltip id="button-view-open-item">
                                      {data?.ledger_details?.legal_name}
                                    </Tooltip>
                                  }
                                >
                                  <span
                                    className="text-start pointer"
                                    style={{
                                      color: "#262a44",
                                      fontSize: "14px",
                                      textUnderlineOffset: "0.3em",
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    {data?.ledger_details?.legal_name.slice(
                                      0,
                                      20
                                    )}
                                    ...
                                  </span>
                                </OverlayTrigger>
                              ) : (
                                <span
                                  className="text-start pointer"
                                  style={{
                                    color: "#262a44",
                                    fontSize: "14px",
                                    textUnderlineOffset: "0.3em",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  {data?.ledger_details?.legal_name}
                                </span>
                              )}
                            </div>
                          </td>
                        )
                      );
                    }
                  };
                  return <td style={{ padding: "0px" }}>{ledgerFun()}</td>;
                } else if (header?.value === "debit") {
                  const debitLedgerFun = () => {
                    return data?.payment?.length > 0 ? (
                      <td
                        className={
                          data?.payment?.length ? "d-flex flex-column p-0" : ""
                        }
                        style={{ border: "0px" }}
                      >
                        {data?.payment?.map((ledger: any, index: number) => {
                          return (
                            <td
                              className={
                                index === data?.payment?.length - 1
                                  ? "border-0"
                                  : ""
                              }
                              style={{
                                borderTop: "0px",
                                borderRight: "0px",
                                borderLeft: "0px",
                                height: "58px",
                              }}
                            >
                              {currencySignAndNegativeValueAdjust(
                                currencySign,
                                ledger?.amount
                                  ? ledger?.amount?.toString()
                                  : "0"
                              )}
                            </td>
                          );
                        })}
                      </td>
                    ) : (
                      <td style={{ paddingTop: "14px", border: "0px" }}>
                        {currencySignAndNegativeValueAdjust(
                          currencySign,
                          data?.invoice_value
                            ? data?.invoice_value?.toString()
                            : "0"
                        )}
                      </td>
                    );
                  };

                  const ledgerAmountFun = () => {
                    return (
                      data?.payment?.length > 0 && (
                        <td
                          className={
                            data?.payment?.length
                              ? "d-flex flex-column p-0"
                              : ""
                          }
                          style={{ border: "0px" }}
                        >
                          {data?.payment?.map((ledger: any, index: number) => {
                            return (
                              <td
                                style={{
                                  borderTop: "0px",
                                  borderRight: "0px",
                                  borderLeft: "0px",
                                  height: "58px",
                                }}
                              >
                                <span
                                  className="text-start pointer"
                                  style={{
                                    color: "#262a44",
                                    fontWeight: "500",
                                    fontSize: "14px",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  {ledger?.transaction_type == "debit"
                                    ? currencySign
                                    : ""}
                                  {ledger?.transaction_type == "debit"
                                    ? ledger?.amount
                                    : "--/--"}
                                </span>
                              </td>
                            );
                          })}
                        </td>
                      )
                    );
                  };

                  if (
                    (data?.invoice_type == 1 &&
                      data?.document_type?.value !== "credit_note") ||
                    (data?.invoice_type === 2 &&
                      data?.document_type?.value === "credit_note")
                  ) {
                    return (
                      <td style={{ padding: "0px" }}>
                        {(data?.invoice_type == 1 &&
                          data?.document_type?.value !== "credit_note") ||
                        (data?.invoice_type === 2 &&
                          data?.document_type?.value === "credit_note")
                          ? debitLedgerFun()
                          : empty()}
                      </td>
                    );
                  } else if (data?.invoice_type === 3) {
                    return (
                      <td style={{ padding: "0px" }}>{ledgerAmountFun()}</td>
                    );
                  } else {
                    return <td style={{ padding: "0px" }}>{empty()}</td>;
                  }
                } else if (header?.value === "credit") {
                  const creditLedgerFun = () => {
                    return data?.payment?.length > 0 ? (
                      <td
                        className={
                          data?.payment?.length ? "d-flex flex-column p-0" : ""
                        }
                        style={{ border: "0px" }}
                      >
                        {data?.payment?.map((ledger: any, index: number) => {
                          return (
                            <td
                              className={
                                index === data?.payment?.length - 1
                                  ? "border-0"
                                  : ""
                              }
                              style={{
                                borderTop: "0px",
                                borderRight: "0px",
                                borderLeft: "0px",
                                height: "58px",
                              }}
                            >
                              {currencySignAndNegativeValueAdjust(
                                currencySign,
                                ledger?.amount
                                  ? ledger?.amount?.toString()
                                  : "0"
                              )}
                            </td>
                          );
                        })}
                      </td>
                    ) : (
                      <td
                        className="pt-3"
                        style={{ paddingTop: "14px", border: "0px" }}
                      >
                        {currencySignAndNegativeValueAdjust(
                          currencySign,
                          data?.invoice_value
                            ? data?.invoice_value?.toString()
                            : "0"
                        )}
                      </td>
                    );
                  };

                  const creditAmountFun = () => {
                    return (
                      data?.payment?.length > 0 && (
                        <td
                          className={
                            data?.payment?.length
                              ? "d-flex flex-column p-0"
                              : ""
                          }
                          style={{ border: "0px" }}
                        >
                          {data?.payment?.map((ledger: any, index: number) => {
                            return (
                              <td
                                style={{
                                  borderTop: "0px",
                                  borderRight: "0px",
                                  borderLeft: "0px",
                                  height: "58px",
                                }}
                              >
                                <span
                                  className="text-start pointer"
                                  style={{
                                    color: "#262a44",
                                    fontWeight: "500",
                                    fontSize: "14px",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  {ledger?.transaction_type == "credit"
                                    ? currencySign
                                    : ""}
                                  {ledger?.transaction_type == "credit"
                                    ? ledger?.amount
                                    : "--/--"}
                                </span>
                              </td>
                            );
                          })}
                        </td>
                      )
                    );
                  };

                  if (
                    (data?.invoice_type === 2 &&
                      data?.document_type?.value !== "credit_note") ||
                    (data?.invoice_type === 1 &&
                      data?.document_type?.value === "credit_note")
                  ) {
                    return (
                      <td style={{ padding: "0px" }}>
                        {(data?.invoice_type === 2 &&
                          data?.document_type?.value !== "credit_note") ||
                        (data?.invoice_type === 1 &&
                          data?.document_type?.value === "credit_note")
                          ? creditLedgerFun()
                          : empty()}
                      </td>
                    );
                  } else if (data?.invoice_type === 3) {
                    return (
                      <td style={{ padding: "0px" }}>{creditAmountFun()}</td>
                    );
                  } else {
                    return <td style={{ padding: "0px" }}>{empty()}</td>;
                  }
                } else if (data[header?.value]) {
                  return (
                    <td className="text-start">
                      {" "}
                      {data[header?.value]?.value}
                    </td>
                  );
                } else {
                  return <td> --/-- </td>;
                }
              })}
            </tr>
          );
        })}
    </>
  );
};

export default DayBookTableData;
